import { render, staticRenderFns } from "./Soluciones.vue?vue&type=template&id=bf4e15c0"
import script from "./Soluciones.vue?vue&type=script&lang=js"
export * from "./Soluciones.vue?vue&type=script&lang=js"
import style0 from "./Soluciones.vue?vue&type=style&index=0&id=bf4e15c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports